import { render, staticRenderFns } from "./NewHomenajeados.vue?vue&type=template&id=2147da18&"
import script from "./NewHomenajeados.vue?vue&type=script&lang=js&"
export * from "./NewHomenajeados.vue?vue&type=script&lang=js&"
import style0 from "./NewHomenajeados.vue?vue&type=style&index=0&id=2147da18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports